import { Radio } from 'antd';
import { AppBox } from './boxes/AppBox';

export function AppRadioButton({ as, ...rest }) {
  return <AppBox {...rest} as={Radio.Button} />;
}
